import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CollaudoHeader } from "@/components/collaudo/CollaudoHeader";
import { BudgetCard } from "@/components/collaudo/BudgetCard";
import { CasesTable } from "@/components/collaudo/CasesTable";
import { FieldsTable } from "@/components/collaudo/FieldsTable";
import { DiscrepancyCard } from "@/components/collaudo/DiscrepancyCard";
import { RevisionsSection } from "@/components/collaudo/RevisionsSection";
import { OwnerChecksSection } from "@/components/collaudo/OwnerChecksSection";
import { VariationsSection } from "@/components/collaudo/VariationsSection";
import { IdentityCheckCard } from "@/components/collaudo/IdentityCheckCard";
import { AssistedTrialSection } from "@/components/collaudo/AssistedTrialSection";
import { AssistedTrialUiCard } from "@/components/collaudo/AssistedTrialUiCard";
import { Defect502Card } from "@/components/collaudo/Defect502Card";
import { ReportSection } from "@/components/collaudo/ReportSection";
import { CaseDetailDialog } from "@/components/collaudo/CaseDetailDialog";
import { ConsegnaBlind05Section } from "@/components/collaudo/ConsegnaBlind05Section";
import { Card } from "@/components/collaudo/primitives";

/** Collaudo lettore (Owner/Admin del solo tenant «Collaudo Lettore»): report, 112 dati, budget, revisioni, artefatti. Sole letture. */
export default function CollaudoLettore() {
  const [o, setO] = useState(null);
  const [fields, setFields] = useState(null);
  const [err, setErr] = useState(null);
  const [openCase, setOpenCase] = useState(null);
  useEffect(() => {
    const fmt = (e) => formatApiErrorDetail(e.response?.data?.detail, { status: e.response?.status, network: !e.response });
    api.get("/collaudo-lettore/overview").then(({ data }) => setO(data)).catch((e) => setErr(fmt(e)));
    api.get("/collaudo-lettore/fields").then(({ data }) => setFields(data)).catch((e) => setErr(fmt(e)));
  }, []);
  if (err) return <div className="p-4 text-[11px] border border-risk-300 bg-risk-50 m-4 rounded-md" data-testid="cl-error"><b>Collaudo lettore</b> — non disponibile: {err}</div>;
  if (!o) return <div className="p-4 text-[11px]" data-testid="cl-loading">Collaudo lettore — lettura degli artefatti…</div>;
  const caseIds = (o.cases || []).map((c) => c.case_id);
  const available = new Set((o.artifacts || []).map((a) => a.name));
  return (
    <div className="p-4 space-y-3" data-testid="collaudo-lettore-page">
      <h1 className="font-display font-bold text-xl">Collaudo lettore</h1>
      <CollaudoHeader o={o} fields={fields} />
      <ConsegnaBlind05Section d={o.consegna_blind05} available={available} />
      <BudgetCard b={o.budget} />
      <CasesTable cases={o.cases || []} onOpen={setOpenCase} />
      {fields ? <FieldsTable rows={fields.rows} cases={caseIds} /> : <div className="text-[11px] text-muted-foreground" data-testid="cl-fields-loading">Tabella dei dati confrontati in caricamento…</div>}
      <DiscrepancyCard discrepancies={fields?.discrepancies} />
      <RevisionsSection revs={o.revisions} budget={o.budget} />
      <IdentityCheckCard ic={o.identity_check} />
      <VariationsSection v={o.variations} />
      <OwnerChecksSection checks={o.owner_checks} rectifications={o.rectifications} />
      <AssistedTrialSection t={o.assisted_trial} available={available} v2={o.assisted_trial_v2} />
      <AssistedTrialUiCard t={o.assisted_trial_ui_start} available={available} />
      <Defect502Card d={o.defect_502_fix} />
      <ReportSection />
      <Card title={`Artefatti (${(o.artifacts || []).length})`} subtitle="File di stato, registri, primi risultati congelati, confronti, evidenze delle correzioni. Nessuna password/token." testId="cl-artifacts">
        <div className="grid gap-x-4 gap-y-0.5 sm:grid-cols-2 lg:grid-cols-3 text-[10px]">
          {(o.artifacts || []).map((a) => <a key={a.name} className="link-tech hover:underline truncate" href={a.url} target="_blank" rel="noreferrer" title={a.name}>{a.name} <span className="text-muted-foreground">({Math.max(1, Math.round(a.bytes / 1024))} kB)</span></a>)}
        </div>
      </Card>
      <CaseDetailDialog cid={openCase} onClose={() => setOpenCase(null)} />
    </div>
  );
}
